import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "w-4 h-4", onPick, testId }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testId}>
    {[1, 2, 3, 4, 5].map(i => {
      const on = i <= Math.round(value || 0);
      const icon = <Star className={`${size} ${on ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />;
      return onPick ? <button key={i} type="button" onClick={() => onPick(i)} className="transition-transform hover:scale-110" data-testid={`${testId}-${i}`}>{icon}</button> : <span key={i}>{icon}</span>;
    })}
  </span>
);

export const Rating = ({ s, dark }) => {
  const v = s.review_avg ?? s.google_rating;
  if (!v) return <span className={`text-xs ${dark ? "text-white/70" : "text-slate-400"}`}>No reviews yet</span>;
  const n = s.review_avg != null ? s.review_count : s.google_reviews;
  return <span className={`inline-flex items-center gap-1.5 text-sm ${dark ? "text-white" : "text-slate-700"}`}><Stars value={v} size="w-3.5 h-3.5" /><b>{v}</b><span className={dark ? "text-white/70" : "text-slate-400"}>({n || 0}{s.review_avg == null ? " on Google" : ""})</span></span>;
};
